import { INVESTMENT_RATE_MONTHLY } from "../loanConstants";

/**
 * Growth rate helpers for summary page — strategyData uses percentage strings from portal.
 */
export function getPaymentGrowthDecimalFromStrategy({
  enableGrowth,
  growthRate,
}) {
  if (!enableGrowth || growthRate == null || growthRate === "") return 0;
  return Number(growthRate) / 100;
}

export function getInvestmentGrowthDecimalFromStrategy({
  enableGrowth,
  enableSeparateGrowth,
  investmentGrowthRate,
  growthRate,
}) {
  if (!enableGrowth) return 0;
  if (enableSeparateGrowth && investmentGrowthRate) {
    return Number(investmentGrowthRate) / 100;
  }
  if (growthRate) {
    return Number(growthRate) / 100;
  }
  return 0;
}

/**
 * Investment portfolio value at end of month `targetMonth` (0-based), matching portal schedule methodology.
 */
export function calculateInvestmentValueAtMonthFromStrategy(strategyData, targetMonth) {
  const {
    enableInvestment,
    monthlyInvestment,
    startingInvestmentCapital,
    enableDelay,
    delayYears,
    delayMonths,
    monthlyPayment,
    minPayment,
    enableGrowth,
    growthRate,
    enableSeparateGrowth,
    investmentGrowthRate,
  } = strategyData;

  if (!enableInvestment) return 0;

  const startingCapital = Number(startingInvestmentCapital) || 0;
  let investmentValue = startingCapital;
  const delayMonthsTotal =
    enableDelay && delayYears ? delayYears * 12 + (delayMonths || 0) : 0;

  const paymentGrowth = getPaymentGrowthDecimalFromStrategy({ enableGrowth, growthRate });
  const investmentGrowth = getInvestmentGrowthDecimalFromStrategy({
    enableGrowth,
    enableSeparateGrowth,
    investmentGrowthRate,
    growthRate,
  });

  for (let month = 0; month < targetMonth; month++) {
    const isInDelayPeriod = month < delayMonthsTotal;

    if (isInDelayPeriod) {
      if (investmentValue > 0) {
        investmentValue = investmentValue * (1 + INVESTMENT_RATE_MONTHLY);
      }
    } else {
      let payment = monthlyPayment;
      if (enableGrowth) {
        const yearsElapsed = Math.floor((month - delayMonthsTotal) / 12);
        payment = monthlyPayment * Math.pow(1 + paymentGrowth, Math.max(0, yearsElapsed));
      }

      const minPaymentRequired = minPayment;
      const availableForInvestment = Math.max(0, payment - minPaymentRequired);

      let investmentContribution = monthlyInvestment;
      if (enableGrowth) {
        const yearsElapsed = Math.floor((month - delayMonthsTotal) / 12);
        investmentContribution =
          monthlyInvestment * Math.pow(1 + investmentGrowth, Math.max(0, yearsElapsed));
      }
      const invest_contrib_t = enableInvestment
        ? Math.min(investmentContribution, availableForInvestment)
        : 0;

      investmentValue = investmentValue * (1 + INVESTMENT_RATE_MONTHLY) + invest_contrib_t;
    }
  }

  return investmentValue;
}
